export default __webpack_public_path__ + "static/media/charactersGirl.1e79ee92.svg";